import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import Icon from '../Icon';
import { Components as ListComponents } from './list.style';
import { activateClickedItem } from './list.util';
const List = _ref => {
  let {
    className = 'list',
    listData,
    noBorder = false,
    onSelect
  } = _ref;
  const [active, setActive] = useState({
    group: -1,
    list: -1
  });
  const [listDataState, setListDataState] = useState(listData);
  const onSelectedActive = (index, subIndex) => {
    var _a, _b, _c, _d;
    setActive({
      group: index,
      list: subIndex
    });
    const currentListData = activateClickedItem(listData, index, subIndex);
    setListDataState(currentListData);
    const selectedItem = {
      group: (_a = currentListData === null || currentListData === void 0 ? void 0 : currentListData[index]) === null || _a === void 0 ? void 0 : _a.group,
      items: (_b = currentListData === null || currentListData === void 0 ? void 0 : currentListData[index]) === null || _b === void 0 ? void 0 : _b.items.filter(m => m.active)
    };
    if ((_d = (_c = currentListData === null || currentListData === void 0 ? void 0 : currentListData[index]) === null || _c === void 0 ? void 0 : _c.items) === null || _d === void 0 ? void 0 : _d.length) onSelect === null || onSelect === void 0 ? void 0 : onSelect(selectedItem);
  };
  return _jsx(_Fragment, {
    children: listDataState && _jsx(ListComponents.Wrapper, _extends({
      className: className,
      noBorder: noBorder
    }, {
      children: listDataState === null || listDataState === void 0 ? void 0 : listDataState.map((item, index) => {
        var _a;
        return _jsxs(React.Fragment, {
          children: [(item === null || item === void 0 ? void 0 : item.group) && _jsx(ListComponents.Item, _extends({
            staticItem: true
          }, {
            children: _jsx(ListComponents.Content, {
              children: _jsx("p", {
                children: item === null || item === void 0 ? void 0 : item.group
              })
            })
          })), (_a = item === null || item === void 0 ? void 0 : item.items) === null || _a === void 0 ? void 0 : _a.map((subList, subIndex) => _jsxs(React.Fragment, {
            children: [_jsxs(ListComponents.Item, _extends({
              disabled: subList.disabled,
              className: active.group === index && active.list === subIndex || subList.active ? 'active' : '',
              active: active.group === index && active.list === subIndex || subList.active,
              indented: !!(item.group || subList.indented),
              onClick: () => onSelectedActive(index, subIndex)
            }, {
              children: [subList.graphic && _jsx(ListComponents.Graphics, {
                children: subList.graphic
              }, subIndex), subList.iconName && _jsx(ListComponents.Icon, {
                children: _jsx(Icon, {
                  name: subList.iconName
                })
              }), _jsxs(ListComponents.Content, _extends({
                active: active.group === index && active.list === subIndex || subList.active,
                disabled: subList.disabled
              }, {
                children: [_jsx("p", {
                  children: subList.value
                }, subIndex), subList.secondaryValue && _jsx("span", {
                  children: subList.secondaryValue
                })]
              })), subList.trailingIcon && _jsx(ListComponents.TrailingIcon, {
                children: _jsx(Icon, {
                  name: subList.trailingIcon
                })
              })]
            })), subList.seperator && _jsx("hr", {})]
          }, subIndex))]
        }, index);
      })
    }))
  });
};
export default List;